export const API_PORT = '4000'
export const API_STAGING = `https://front-api.staging.lpata.ru/api/`
export const API_ORIGIN = `https://front-api.lpata.ru/api/`
export const API_URL =  API_ORIGIN//`https://front-api.lpata.ru/api`
export const DOMAIN_TITLE = 'Lopata Admin Panel'
export const STAT_API_URL = 'https://statistics.staging.lpata.ru/';

